export const Tabs = {
    activateTab($tabButton) {
        var $tabs = $tabButton.parents('.tabs');
        var index = $tabButton.parent().index();

        // set the button
        $tabButton
            .attr('aria-pressed', 'true')
            .attr('tabindex', '0')
            .parent()
            .attr('open', true)
            .siblings()
            .attr('open', false)
            .find('[data-tabs-button]')
            .attr('aria-pressed', 'false')
            .attr('tabindex', '-1');

        // set the panel
        $('[data-tabs-panel]', $tabs)
            .eq(index)
            .attr('open', true)
            .attr('data-tabs-panel-active', 'true')
            .attr('tabindex', '0')
            .siblings()
            .attr('open', false)
            .attr('data-tabs-panel-active', 'false')
            .attr('tabindex', '-1');
    },
    init() {
        $('[data-tabs-container]').each(function () {
            const $tabs = $(this);
            const tabs = $('[data-tabs-button]', $tabs);
            const panels = $('[data-tabs-panel]', $tabs);

            $('[data-tabs-button]', $tabs)
                .on('click', function () {
                    Tabs.activateTab($(this));
                    return false;
                })
                .on('keydown', function (e) {
                    var index = $(this).parent().index();

                    if (e.keyCode === 37) {
                        if (index === 0) {
                            $('[data-tabs-button]', $tabs)
                                .eq($('[data-tabs-button]', $tabs).length - 1)
                                .focus();
                        } else {
                            $('[data-tabs-button]', $tabs)
                                .eq(index - 1)
                                .focus();
                        }
                    }

                    if (e.keyCode === 39) {
                        if (index === tabs.length - 1) {
                            $('[data-tabs-button]', $tabs).eq(0).focus();
                        } else {
                            $('[data-tabs-button]', $tabs)
                                .eq(index + 1)
                                .focus();
                        }
                    }
                });

            Tabs.activateTab($('[data-tabs-button]', $tabs).eq(0));
        });
    },
};

